import { Col, Row } from 'react-bootstrap';
import FormWithProvider from 'components/forms/form/Form';
import useAnalyticsInit from './analytics/useAnalyticsInit';
import AnalyticsFiltersWrapper from './analytics/filters/AnalyticsFiltersWrapper';
import { ChartsAndPiesWrapper } from './Analytics.styles';
import AnalyticsList from './analytics/cards/AnalyticsList';
import ChartsFilters from './analytics/charts/filters/ChartsFilters';
import ChartsWrapper from './analytics/charts/ChartsWrapper';
import ChannelPieChart from './analytics/charts/ChannelPieChart';
import RevParPieChart from './analytics/charts/RevParPieChart';
import ChartsFilterFormWatcher from './analytics/charts/ChartsFilterFormWatcher';

const AnalyticsWrapper = () => {
  const { chartFormSchema, isLoading, chartFormDefaultValues } =
    useAnalyticsInit();

  return (
    <FormWithProvider
      defaultValues={chartFormDefaultValues}
      onSubmit={() => {}}
      schema={chartFormSchema()}
    >
      {/*
       // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified */}
      <AnalyticsFiltersWrapper isLoading={isLoading} />
      <Row>
        <AnalyticsList />
      </Row>
      <ChartsAndPiesWrapper>
        <Col data-testid="charts-container" md={7} xs={12}>
          <ChartsFilters />
          <ChartsFilterFormWatcher />
          <ChartsWrapper />
        </Col>
        <Col mdOffset={1} md={4} xs={12}>
          <ChannelPieChart />
          <RevParPieChart />
        </Col>
      </ChartsAndPiesWrapper>
    </FormWithProvider>
  );
};

export default AnalyticsWrapper;
